import Modal from "components/dialogs/Modal"
import React from "react"
import { Account } from "sharedTypes"
import PlansGrid from "pages/Account/Plan/PlansGrid"
import usePlans from "queries/plans"
import Spinner from "components/elements/Spinner"
import Icon from "components/elements/Icon"

type Props = {
  currentAccount: Account
  onHide: () => void
  defaultSelectedPlan?: string
}

const UpgradePlan = ({
  currentAccount,
  onHide,
  defaultSelectedPlan,
}: Props) => {
  const { isLoading, plans } = usePlans()
  if (isLoading) { return <Spinner /> }

  const upgradeablePlans = plans.filter((plan) => plan.downgradeOnly !== true)

  return (
    <Modal
      title={<Icon size={30} h={8} icon="diobox-logo" color="blue.500" />}
      show
      hide={onHide}
      size="full"
      noPadding
      closeOnEsc={false}
    >
      <PlansGrid
        plans={upgradeablePlans}
        currentAccount={currentAccount}
        defaultSelectedPlan={defaultSelectedPlan}
      />
    </Modal>
  )
}

export default UpgradePlan
